/**
 * Normalised API error. The API returns RFC 9457 style problem details:
 * { type, title, status, detail, code, errors? }. Everything in the app catches
 * this one class instead of inspecting raw responses.
 */
export type ProblemDetails = {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  code?: string;
  errors?: Record<string, string[]>;
};

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly fieldErrors: Record<string, string[]>;

  constructor(status: number, problem: ProblemDetails | undefined, fallback = "Request failed") {
    super(problem?.detail ?? problem?.title ?? fallback);
    this.name = "ApiError";
    this.status = status;
    this.code = problem?.code ?? `http_${status}`;
    this.fieldErrors = problem?.errors ?? {};
  }
}
